import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"
import PhotoSwipe from "photoswipe"
import PhotoSwipeLightbox from "photoswipe/lightbox"

export default class extends Controller {
  static values = {
    slidesPerView: { type: Number, default: 1 },
    spaceBetween: { type: Number, default: 30 },
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: false },
    autoplayDelay: { type: Number, default: 3000 },
    // PhotoSwipe values
    photoswipeSelector: { type: String, default: ".gallery-item" },
    showHideAnimationType: { type: String, default: "zoom" },
    zoomAnimationDuration: { type: Number, default: 366 },
    allowPanToNext: { type: Boolean, default: true },
    spacing: { type: Number, default: 0.1 },
    photoswipeLoop: { type: Boolean, default: true },
    pinchToClose: { type: Boolean, default: true },
    closeOnVerticalDrag: { type: Boolean, default: true },
    hideAnimationDuration: { type: Number, default: 333 },
    showAnimationDuration: { type: Number, default: 333 }
  }

  connect() {
    // Initialize Swiper
    this.swiper = new Swiper(this.element.querySelector(".swiper"), {
      modules: [Navigation, Pagination],
      slidesPerView: this.slidesPerViewValue,
      spaceBetween: this.spaceBetweenValue,
      loop: this.loopValue,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      }
    })

    // Initialize PhotoSwipe Lightbox for gallery items
    const galleryElement = this.element.querySelector(".swiper-wrapper")
    if (galleryElement) {
      // Map data-sub-html to title attribute for PhotoSwipe caption support
      const items = galleryElement.querySelectorAll(this.photoswipeSelectorValue)
      items.forEach((item) => {
        if (item.dataset.subHtml && !item.title) {
          item.title = item.dataset.subHtml
        }
      })

      // Initialize PhotoSwipe Lightbox
      this.lightbox = new PhotoSwipeLightbox({
        gallery: galleryElement,
        children: this.photoswipeSelectorValue,
        pswpModule: PhotoSwipe,
        showHideAnimationType: this.showHideAnimationTypeValue,
        zoomAnimationDuration: this.zoomAnimationDurationValue,
        allowPanToNext: this.allowPanToNextValue,
        spacing: this.spacingValue,
        loop: this.photoswipeLoopValue,
        pinchToClose: this.pinchToCloseValue,
        closeOnVerticalDrag: this.closeOnVerticalDragValue,
        hideAnimationDuration: this.hideAnimationDurationValue,
        showAnimationDuration: this.showAnimationDurationValue
      })

      this.lightbox.init()
    }
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }
}

